let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ahxSD"), load("7zMjZ"), load("a1dBM"), load("65aDe")]).then(() => parcelRequire('71Xxe'));